<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            navigationPath="StudentView"
            navigationField="studentID"
            :selectionEnabled="true"
        ></dx-grid>

        <v-dialog v-model="updateBusDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2">Update Bus</v-card-title>
                <div class="px-2 mt-2">
                    <div style="overflow-y: auto; height: 300px">
                        <div v-for="(student, index) in selected">
                            <div class="font-weight-medium">
                                {{
                                    student.hebName +
                                        " " +
                                        student.lastNameH +
                                        " (" +
                                        student.branch +
                                        " | " +
                                        student.class +
                                        ")"
                                }}
                            </div>
                            <div class="caption">
                                Father: {{ student.hname }}
                            </div>
                            <div class="caption">
                                {{ student.busAddress1 }}
                            </div>
                            <div class="body-2">
                                {{ student.homePhone }}
                            </div>
                            <v-divider
                                class="my-2"
                                v-if="index + 1 < selected.length"
                            ></v-divider>
                        </div>
                    </div>
                    <!-- <v-select
                        v-model="bus"
                        label="Bus"
                        outline
                        class="mb-2 mt-2"
                        :rules="[rules.required]"
                        ref="bus"
                        :items="buses.map((b) => b.busDescribtion)"
                    ></v-select> -->
                    <v-autocomplete
                        class="mb-3 mt-2"
                        hide-details
                        label="Bus"
                        placeholder="Start typing..."
                        hide-no-data
                        ref="bus"
                        outline
                        v-model="bus"
                        :items="busesBulk.map((b) => b.busDescribtion)"
                        :search-input.sync="loadBusesSearchBulk"
                        clearable
                    ></v-autocomplete>
                </div>
                <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="updateBusDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="saveBusInBulk"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="updateDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2"
                    >Update Student</v-card-title
                >

                <div class="px-2 mt-2">
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium">
                            {{
                                clickedRow.hebName +
                                    " " +
                                    clickedRow.lastNameH +
                                    " (" +
                                    clickedRow.branch +
                                    " | " +
                                    clickedRow.class +
                                    ")"
                            }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Father</div>
                        <div>{{ clickedRow.hname }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Address</div>
                        <div>
                            {{ clickedRow.busAddress1 }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Primary Phone
                        </div>
                        <div>{{ clickedRow.homePhone }}</div>
                    </v-layout>
                    <!-- <v-select
                        v-model="clickedRow.bus"
                        label="Bus"
                        outline
                        class="mb-0 mt-3"
                        :rules="[rules.required]"
                        ref="selectedBus"
                        :items="buses.map((b) => b.busDescribtion)"
                    ></v-select> -->

                    <v-autocomplete
                        class="mb-4 mt-3"
                        hide-details
                        outline
                        label="Bus"
                        placeholder="Start typing..."
                        hide-no-data
                        ref="selectedBus"
                        v-model="clickedRow.bus"
                        :rules="[rules.required]"
                        :items="buses.map((b) => b.busDescribtion)"
                        :search-input.sync="loadBusesSearch"
                        clearable
                    ></v-autocomplete>
                </div>
                <v-card-actions class="pt-0 mr-2 mt-0 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="updateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="saveBus()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="applicationInfoDialog" max-width="1300" persistent>
            <v-card style="height: 90vh; display: flex; flex-direction: column;">
                <v-card-title class="headline success white--text py-2">
                    Application Information
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="closeApplicationInfoDialog"
                        class="white--text my-0"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-2" style="flex: 1; overflow-y: auto;">
                    <div
                        class="mb-3 pa-2"
                        style="background-color: #f5f5f5; border-radius: 4px; font-size: 12px;"
                    >
                        <v-layout row wrap>
                            <v-flex xs4>
                                <div>
                                    <span class="font-weight-medium">Name:</span>
                                    {{ selectedStudent.hebName }}
                                    {{ selectedStudent.lastNameH }}
                                </div>
                                <div>
                                    <span class="font-weight-medium">Father:</span>
                                    {{ selectedStudent.father }}
                                </div>
                                <div>
                                    <span class="font-weight-medium">Address:</span>
                                    {{ selectedStudent.address1 }}
                                </div>
                            </v-flex>
                            <v-flex xs4>
                                <div>
                                    <span class="font-weight-medium">Account ID:</span>
                                    {{ selectedStudent.familyID }}
                                </div>
                                <div>
                                    <span class="font-weight-medium">Home Phone:</span>
                                    {{ selectedStudent.homePhone }}
                                </div>
                            </v-flex>
                            <v-flex xs4>
                                <div>
                                    <span class="font-weight-medium">Paternal Grandparent:</span>
                                    {{ selectedStudent.paternalGrandParent }}
                                </div>
                                <div>
                                    <span class="font-weight-medium">Maternal Grandparent:</span>
                                    {{ selectedStudent.maternalGrandParent }}
                                </div>
                            </v-flex>
                        </v-layout>
                    </div>

                    <v-layout row wrap>
                        <v-flex xs4 class="pr-4">
                            <div
                                class="pa-3 mb-3"
                                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
                            >
                                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                                    טאטע
                                </div>

                                <v-combobox
                                    ref="fatherCityCombo"
                                    v-model="applicationInfo.fatherCity"
                                    :items="fatherCityOptions"
                                    label="טאטע געוואוינט אין"
                                    dense
                                    hide-details
                                    class="mb-2"
                                    clearable
                                ></v-combobox>

                                <v-combobox
                                    ref="fatherSchoolCombo"
                                    v-model="applicationInfo.fatherSchool"
                                    :items="fatherSchoolOptions"
                                    label="?טאטע איז א תלמיד פון חדר"
                                    dense
                                    hide-details
                                    class="mb-2"
                                    clearable
                                ></v-combobox>

                                <v-text-field
                                    v-model="applicationInfo.fatherYeshivahKetana"
                                    label="?טאטע איז א תלמיד פון ישיבה קטנה"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-text-field
                                    v-model="applicationInfo.fatherYeshivahGedolah"
                                    label="?טאטע איז א תלמיד פון ישיבה גדולה"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>
                            </div>

                            <div
                                class="pa-3 mb-3"
                                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
                            >
                                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                                    מאמע
                                </div>

                                <v-combobox
                                    ref="motherSchoolCombo"
                                    v-model="applicationInfo.motherSchool"
                                    :items="motherSchoolOptions"
                                    label="?מאמע איז תלמידה פון"
                                    dense
                                    hide-details
                                    class="mb-2"
                                    clearable
                                ></v-combobox>

                                <v-text-field
                                    v-model="applicationInfo.motherGraduatedYear"
                                    label="?וועלכע יאר גענדיגט די 11 טע קלאס"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>
                            </div>

                            <div
                                class="pa-3 mb-3"
                                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
                            >
                                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                                    Landlord
                                </div>

                                <v-text-field
                                    v-model="applicationInfo.landlord"
                                    label="Landlord"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-text-field
                                    v-model="applicationInfo.landlordPhone"
                                    label="Landlord Phone"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>
                            </div>

                            <div
                                class="pa-3 mb-3"
                                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
                            >
                                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                                    Emergency Contact
                                </div>

                                <v-text-field
                                    v-model="applicationInfo.inCaseOfEmergencyName"
                                    label="Emergency Contact Name"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-text-field
                                    v-model="applicationInfo.inCaseOfEmergencyPhone"
                                    label="Emergency Contact Phone #"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>
                            </div>

                            <div
                                class="pa-3 mb-3"
                                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
                            >
                                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                                    Country
                                </div>

                                <v-text-field
                                    v-model="applicationInfo.country"
                                    label="Country"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>
                            </div>
                        </v-flex>

                        <v-flex xs4 class="pr-4">
                            <div
                                class="pa-3 mb-3"
                                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
                            >
                                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                                    ארבעט
                                </div>

                                <div
                                    class="font-weight-bold mb-2 mt-2"
                                    style="font-size: 13px;"
                                >
                                    טאטע'ס ארבעט
                                </div>

                                <v-text-field
                                    v-model="applicationInfo.workPlaceOrBoss"
                                    label="ארבעט"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-text-field
                                    v-model="applicationInfo.workBoss"
                                    label="נאמען פון בעה''ב"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-select
                                    v-model="applicationInfo.workType"
                                    label="Work Type"
                                    :items="workTypeOptions"
                                    dense
                                    hide-details
                                    class="mb-2"
                                    clearable
                                ></v-select>

                                <v-text-field
                                    v-model="applicationInfo.workAddress"
                                    label="Work Address"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-text-field
                                    v-model="applicationInfo.workPhone"
                                    label="Work Phone #"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-combobox
                                    ref="workPositionCombo"
                                    v-model="applicationInfo.workPosition"
                                    :items="workPositionOptions"
                                    label="Work Position"
                                    dense
                                    hide-details
                                    class="mb-2"
                                    clearable
                                ></v-combobox>

                                <v-text-field
                                    v-model.number="applicationInfo.yearsInPosition"
                                    label="Years In Position"
                                    type="number"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <div
                                    class="font-weight-bold mb-2 mt-3"
                                    style="font-size: 13px;"
                                >
                                    מאמע'ס ארבעט
                                </div>

                                <v-text-field
                                    v-model="applicationInfo.wifeWorkPlaceOrBoss"
                                    label="ארבעט"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-text-field
                                    v-model="applicationInfo.wifeWorkBoss"
                                    label="נאמען פון בעה''ב"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-select
                                    v-model="applicationInfo.wifeWorkType"
                                    label="Work Type"
                                    :items="workTypeOptions.filter((v) => v != 'כולל')"
                                    dense
                                    hide-details
                                    class="mb-2"
                                    clearable
                                ></v-select>

                                <v-text-field
                                    v-model="applicationInfo.wifeWorkAddress"
                                    label="Work Address"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-text-field
                                    v-model="applicationInfo.wifeWorkPhone"
                                    label="Work Phone #"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-combobox
                                    ref="wifeWorkPositionCombo"
                                    v-model="applicationInfo.wifeWorkPosition"
                                    :items="wifeWorkPositionOptions"
                                    label="Work Position"
                                    dense
                                    hide-details
                                    class="mb-2"
                                    clearable
                                ></v-combobox>

                                <v-text-field
                                    v-model.number="applicationInfo.wifeYearsInPosition"
                                    label="Years In Position"
                                    type="number"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>
                            </div>
                        </v-flex>

                        <v-flex xs4>
                            <div
                                class="pa-3 mb-3"
                                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
                            >
                                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                                    ביהמ"ד
                                </div>

                                <v-text-field
                                    v-model="applicationInfo.shabbatSynagogue"
                                    label="וואכן ביהמ''ד"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-text-field
                                    v-model="applicationInfo.weekdaySynagogue"
                                    label="שבת ביהמ''ד"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-text-field
                                    v-model="applicationInfo.dayan"
                                    label="דיין"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-checkbox
                                    v-model="applicationInfo.isSatmarMember"
                                    label="קיט''ל מעמבער"
                                    color="success"
                                    hide-details
                                    class="mt-1 mb-2"
                                ></v-checkbox>
                            </div>

                            <div
                                class="pa-3 mb-3"
                                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
                            >
                                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                                    קינדער
                                </div>

                                <v-text-field
                                    v-model.number="applicationInfo.kidsAtHome"
                                    label="?וויפיל קינדער האט איר אין שטוב"
                                    dense
                                    hide-details
                                    type="number"
                                    class="mb-2"
                                ></v-text-field>

                                <v-checkbox
                                    v-model="applicationInfo.kidsInOtherSchool"
                                    label="?האט איר קינדער אין אנדערע מוסדות"
                                    color="success"
                                    hide-details
                                    class="mb-2"
                                ></v-checkbox>

                                <v-combobox
                                    ref="otherSchoolCombo"
                                    v-model="applicationInfo.otherSchool"
                                    :items="otherSchoolOptions"
                                    label="נאמען פון מוסד"
                                    dense
                                    hide-details
                                    class="mb-2"
                                    clearable
                                ></v-combobox>

                                <v-combobox
                                    ref="playGroupCombo"
                                    v-model="applicationInfo.playGroup"
                                    :items="playGroupOptions"
                                    label="Play Group"
                                    dense
                                    hide-details
                                    class="mb-2"
                                    clearable
                                ></v-combobox>
                            </div>

                            <div
                                class="pa-3 mb-3"
                                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
                            >
                                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                                    Benefits & Programs
                                </div>

                                <v-text-field
                                    v-model="applicationInfo.foodStampCase"
                                    label="Food Stamp Case #"
                                    dense
                                    hide-details
                                    class="mb-2"
                                ></v-text-field>

                                <v-select
                                    v-model="applicationInfo.vouchers"
                                    label="Vouchers"
                                    :items="voucherTypeOptions"
                                    dense
                                    hide-details
                                    class="mb-2"
                                    clearable
                                ></v-select>

                                <v-textarea
                                    v-model="applicationInfo.note"
                                    label="Note"
                                    rows="2"
                                    outline
                                    hide-details
                                    class="mb-2"
                                ></v-textarea>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="py-2 pr-1 my-2" style="flex-shrink: 0;">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeApplicationInfoDialog">
                        Cancel
                    </v-btn>
                    <v-btn
                        color="success"
                        :loading="applicationInfoProcessing"
                        @click="saveApplicationInfo"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { loadOptions } from "../utils/smLookup.js";

export default {
    data: () => ({
        title: "Students",

        actions: [],
        userBranch: "",
        url: "",
        regID: "",

        updateBusDialog: false,
        processing: false,
        bus: "",
        selected: [],
        busesAll: [],
        buses: [],
        busesBulk: [],
        loadBusesSearch: null,
        loadBusesSearchBulk: null,
        updateDialog: false,
        clickedRow: {},
        applicationInfoDialog: false,
        applicationInfoProcessing: false,
        applicationInfo: {},
        selectedStudent: {},
        otherSchoolOptions: [],
        playGroupOptions: [],
        voucherTypeOptions: [],
        motherSchoolOptions: [],
        fatherCityOptions: [],
        fatherSchoolOptions: [],
        workTypeOptions: [],
        workPositionOptions: [],
        wifeWorkPositionOptions: [],

        rules: {
            required: (value) => !!value || "Required.",
        },

        columns: [
            {
                label: "Provider",
                field: "provider",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "engName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name H",
                field: "lastNameH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name H",
                field: "hebName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student ID",
                field: "studentID",
                link: "StudentView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "familyID",
                label: "Account ID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "HasApplicantInfo",
                field: "hasApplicantInfo",
                format: "",
                visible: false,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "ApplicantInfoCount",
                field: "applicantInfoCount",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                template: "link-action-cell-template",
                showLink: (row) => {
                    return true;
                },
            },
            {
                label: "Building",
                field: "building",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "class",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher",
                field: "teacherH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher 2",
                field: "teacherH2",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address1",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Address",
                field: "busAddress1",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Code",
                field: "busCode",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                template: "link-action-cell-template",
                showLink: (row) => {
                    return true;
                },
            },
            {
                label: "Bus House",
                field: "busHouse",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Street",
                field: "busStreet",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },

            {
                label: "Pending Bus Code",
                field: "pendingBusCode",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Has Pending Bus Change",
                field: "hasPendingBusChange",
                format: "",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Changed At",
                field: "busChangedAt",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "Special Needs Program",
            //     field: "specialNeedsProgram",
            //     format: "",
            //     visible: true,
            //     type: "boolean",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
        ],
    }),
    watch: {
        loadBusesSearch(value) {
            if (!value) {
                this.loadBuses();

                return;
            }

            if (!this.busesAll.length) return;

            this.buses = this.busesAll.filter((b) =>
                b.busDescribtion.toUpperCase().startsWith(value.toUpperCase()),
            );
        },
        loadBusesSearchBulk(value) {
            if (!value) {
                this.loadBuses();

                return;
            }

            if (!this.busesAll.length) return;

            this.busesBulk = this.busesAll.filter((b) =>
                b.busDescribtion.toUpperCase().startsWith(value.toUpperCase()),
            );
        },
    },
    async created() {
        this.columns.find(
            (c) => c.field == "familyID",
        ).showLink = this.showLink;

        const canViewApplicantInfo = this.hasApplicantInfoAccess();
        this.columns.find(
            (c) => c.field == "hasApplicantInfo",
        ).visible = canViewApplicantInfo;
        this.columns.find(
            (c) => c.field == "applicantInfoCount",
        ).visible = canViewApplicantInfo;

        this.columns.find((c) => c.field == "busCode").linkAction = (row) => {
            this.openUpdateDialog(row);
        };
        this.columns.find(
            (c) => c.field == "applicantInfoCount",
        ).linkAction = (row) => {
            this.openApplicationInfoDialog(row);
        };

        this.loadBuses();
    },
    beforeDestroy() {},
    methods: {
        async beforeSetupGrid() {
            this.userBranch = this.$store.state.authentication.branch;

            this.actions.push({
                text: "Update Bus",
                action: this.openUpdateBus,
                showOnSelection: true,
            });

            let url =
                "allStudents?" +
                (this.userBranch != "null"
                    ? "branch=" + this.userBranch
                    : "branch=");

            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms,
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url = url += "&grade=&section=&regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/allStudents/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/allStudents/getRegTerms");
        },
        async loadBuses() {
            this.busesAll = await this.$http.get("api/Students/GetBuses");
            this.buses = this.busesAll;
            this.busesBulk = this.busesAll;
        },
        onTermSelected(value) {
            this.regID = value;

            let url =
                "allStudents?" +
                (this.userBranch != "null"
                    ? "branch=" + this.userBranch
                    : "branch=");

            this.url = url += "&grade=&section=&regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        openUpdateDialog(row) {
            this.clickedRow = JSON.parse(JSON.stringify(row));

            if (this.clickedRow.busCode) {
                const bus = this.buses.find(
                    (b) => b.busCode == this.clickedRow.busCode,
                );

                this.clickedRow.bus = bus ? bus.busDescribtion : "";
            }

            this.updateDialog = true;

            this.$refs.selectedBus.resetValidation(true);
        },
        showLink() {
            return (
                !this.$store.state.authentication.branch ||
                this.$store.state.authentication.branch == "null"
            );
        },
        hasApplicantInfoAccess() {
            const roles = Array.isArray(this.$store.state.authentication.roles)
                ? this.$store.state.authentication.roles
                : this.$store.state.authentication.roles
                  ? this.$store.state.authentication.roles.split(",")
                  : [];

            return roles.includes("ViewApplicantInfo") || this.isAdmin();
        },
        isAdmin() {
            const isAdmin = this.$store.getters["authentication/isAdmin"];

            if (!isAdmin || isAdmin == "false") return false;

            return true;
        },
        openUpdateBus() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.updateBusDialog = true;
        },
        async openApplicationInfoDialog(row) {
            this.selectedStudent = JSON.parse(JSON.stringify(row));
            this.applicationInfoDialog = true;
            this.applicationInfoProcessing = true;

            try {
                await this.refreshApplicationInfoOptions();

                const response = await this.$http.get(
                    "api/newfamilyapplications/GetApplicationByAccountID?accountid=" +
                        row.familyID,
                );

                this.applicationInfo = {
                    personID: row.personID,
                    accountID: row.familyID,
                    mothersName: response.mothersName || "",
                    mothersNameHeb: response.mothersNameHeb || "",
                    motherCell: response.motherCell || "",
                    landlord: response.landlord || "",
                    landlordPhone: response.landlordPhone || "",
                    workPlaceOrBoss: response.workPlaceOrBoss || "",
                    workBoss: response.workBoss || "",
                    workAddress: response.workAddress || "",
                    workPhone: response.workPhone || "",
                    workType: response.workType || "",
                    workPosition: response.workPosition || "",
                    yearsInPosition: response.yearsInPosition || null,
                    emailAddress: response.emailAddress || "",
                    note: response.note || "",
                    shabbatSynagogue: response.shabbatSynagogue || "",
                    weekdaySynagogue: response.weekdaySynagogue || "",
                    isSatmarMember: response.isSatmarMember || false,
                    dayan: response.dayan || "",
                    inCaseOfEmergencyName: response.inCaseOfEmergencyName || "",
                    inCaseOfEmergencyPhone: response.inCaseOfEmergencyPhone || "",
                    foodStampCase: response.foodStampCase || "",
                    vouchers: response.vouchers || "",
                    fatherCity: response.fatherCity || "",
                    fatherSchool: response.fatherSchool || "",
                    fatherYeshivahKetana: response.fatherYeshivahKetana || "",
                    fatherYeshivahGedolah: response.fatherYeshivahGedolah || "",
                    motherSchool: response.motherSchool || "",
                    motherGraduatedYear: response.motherGraduatedYear || "",
                    kidsAtHome: response.kidsAtHome || null,
                    kidsInOtherSchool: response.kidsInOtherSchool || false,
                    otherSchool: response.otherSchool || "",
                    playGroup: response.playGroup || "",
                    wifeWorkPlaceOrBoss: response.wifeWorkPlaceOrBoss || "",
                    wifeWorkBoss: response.wifeWorkBoss || "",
                    wifeWorkType: response.wifeWorkType || "",
                    wifeWorkAddress: response.wifeWorkAddress || "",
                    wifeWorkPhone: response.wifeWorkPhone || "",
                    wifeWorkPosition: response.wifeWorkPosition || "",
                    wifeYearsInPosition: response.wifeYearsInPosition || null,
                    country: response.country || "",
                };
            } catch (e) {
                console.error("Failed to load application info", e);
                this.applicationInfo = {
                    personID: row.personID,
                    accountID: row.familyID,
                };
            } finally {
                this.applicationInfoProcessing = false;
            }
        },
        closeApplicationInfoDialog() {
            this.applicationInfoDialog = false;
            this.applicationInfo = {};
            this.selectedStudent = {};
        },
        async saveApplicationInfo() {
            try {
                this.applicationInfoProcessing = true;

                if (
                    this.$refs.fatherCityCombo &&
                    this.$refs.fatherCityCombo.internalSearch
                ) {
                    this.applicationInfo.fatherCity = this.$refs.fatherCityCombo.internalSearch;
                }
                if (
                    this.$refs.fatherSchoolCombo &&
                    this.$refs.fatherSchoolCombo.internalSearch
                ) {
                    this.applicationInfo.fatherSchool = this.$refs.fatherSchoolCombo.internalSearch;
                }
                if (
                    this.$refs.otherSchoolCombo &&
                    this.$refs.otherSchoolCombo.internalSearch
                ) {
                    this.applicationInfo.otherSchool = this.$refs.otherSchoolCombo.internalSearch;
                }
                if (
                    this.$refs.playGroupCombo &&
                    this.$refs.playGroupCombo.internalSearch
                ) {
                    this.applicationInfo.playGroup = this.$refs.playGroupCombo.internalSearch;
                }
                if (
                    this.$refs.motherSchoolCombo &&
                    this.$refs.motherSchoolCombo.internalSearch
                ) {
                    this.applicationInfo.motherSchool = this.$refs.motherSchoolCombo.internalSearch;
                }
                if (
                    this.$refs.workPositionCombo &&
                    this.$refs.workPositionCombo.internalSearch
                ) {
                    this.applicationInfo.workPosition = this.$refs.workPositionCombo.internalSearch;
                }
                if (
                    this.$refs.wifeWorkPositionCombo &&
                    this.$refs.wifeWorkPositionCombo.internalSearch
                ) {
                    this.applicationInfo.wifeWorkPosition = this.$refs.wifeWorkPositionCombo.internalSearch;
                }

                await this.$http.post(
                    "api/applicantStudents/saveApplicationInfo",
                    this.applicationInfo,
                );

                this.applicationInfoProcessing = false;
                this.applicationInfoDialog = false;

                this.$notify({
                    text: "Application Information Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.applicationInfoProcessing = false;

                this.$notify({
                    text: "Error saving application information",
                    group: "notification",
                    type: "error",
                });
            }
        },
        async refreshApplicationInfoOptions() {
            await Promise.all([
                this.loadOtherSchoolOptions(),
                this.loadPlayGroupOptions(),
                this.loadVoucherTypeOptions(),
                this.loadMotherSchoolOptions(),
                this.loadFatherCityOptions(),
                this.loadFatherSchoolOptions(),
                this.loadWorkTypeOptions(),
                this.loadWorkPositionOptions(),
                this.loadWifeWorkPositionOptions(),
            ]);
        },
        async loadOtherSchoolOptions() {
            try {
                const response = await this.$http.get(
                    "api/newfamilyapplications/GetUniquePropertyValues?propertyName=OtherSchool",
                );
                this.otherSchoolOptions = response || [];
            } catch (e) {
                console.error("Failed to load other school options", e);
                this.otherSchoolOptions = [];
            }
        },
        async loadFatherCityOptions() {
            try {
                const response = await this.$http.get(
                    "api/newfamilyapplications/GetUniquePropertyValues?propertyName=FatherCity",
                );
                this.fatherCityOptions = response || [];
            } catch (e) {
                console.error("Failed to load father city options", e);
                this.fatherCityOptions = [];
            }
        },
        async loadMotherSchoolOptions() {
            try {
                const response = await this.$http.get(
                    "api/newfamilyapplications/GetUniquePropertyValues?propertyName=MotherSchool",
                );
                this.motherSchoolOptions = response || [];
            } catch (e) {
                console.error("Failed to load mother school options", e);
                this.motherSchoolOptions = [];
            }
        },
        async loadFatherSchoolOptions() {
            try {
                const response = await this.$http.get(
                    "api/newfamilyapplications/GetUniquePropertyValues?propertyName=FatherSchool",
                );
                this.fatherSchoolOptions = response || [];
            } catch (e) {
                console.error("Failed to load father school options", e);
                this.fatherSchoolOptions = [];
            }
        },
        async loadWorkTypeOptions() {
            try {
                const options = await loadOptions("ApplicantWorkType");
                this.workTypeOptions = options.map((o) => o.value);
            } catch (e) {
                console.error("Failed to load work type options", e);
                this.workTypeOptions = [];
            }
        },
        async loadWorkPositionOptions() {
            try {
                const response = await this.$http.get(
                    "api/newfamilyapplications/GetUniquePropertyValues?propertyName=WorkPosition",
                );
                this.workPositionOptions = response || [];
            } catch (e) {
                console.error("Failed to load work position options", e);
                this.workPositionOptions = [];
            }
        },
        async loadWifeWorkPositionOptions() {
            try {
                const response = await this.$http.get(
                    "api/newfamilyapplications/GetUniquePropertyValues?propertyName=WifeWorkPosition",
                );
                this.wifeWorkPositionOptions = response || [];
            } catch (e) {
                console.error("Failed to load wife work position options", e);
                this.wifeWorkPositionOptions = [];
            }
        },
        async loadPlayGroupOptions() {
            try {
                const response = await this.$http.get(
                    "api/newfamilyapplications/GetUniquePropertyValues?propertyName=PlayGroup",
                );
                this.playGroupOptions = response || [];
            } catch (e) {
                console.error("Failed to load play group options", e);
                this.playGroupOptions = [];
            }
        },
        async loadVoucherTypeOptions() {
            try {
                const options = await loadOptions("VoucherType");
                this.voucherTypeOptions = (options || [])
                    .map((o) =>
                        typeof o === "string" ? o : o && (o.value || o.text || o.name),
                    )
                    .filter((o) => !!o);
            } catch (e) {
                console.error("Failed to load voucher type options", e);
                this.voucherTypeOptions = [];
            }
        },
        async saveBus() {
            if (!this.$refs.selectedBus.validate(true)) return;

            const busCode = this.buses.find(
                (b) => b.busDescribtion == this.clickedRow.bus,
            ).busCode;

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/students/saveBusChange",
                    [
                        {
                            studentID: this.clickedRow.studentID,
                            accountID: this.clickedRow.familyID,
                            busCode: busCode,
                            Username: this.$store.state.authentication.user,
                            date: moment().format("YYYY-MM-DD HH:mm:ss"),
                        },
                    ],
                );

                this.processing = false;
                this.updateDialog = false;
                this.clickedRow.bus = "";

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveBusInBulk() {
            if (!this.selected.length) {
                return this.$notify({
                    text: "No Students Selected",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.$refs.bus.validate(true)) return;

            const busCode = this.busesAll.find(
                (b) => b.busDescribtion == this.bus,
            ).busCode;

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/students/saveBusChange",
                    this.selected.map((student) => ({
                        studentID: student.studentID,
                        accountID: student.familyID,
                        busCode: busCode,
                        Username: this.$store.state.authentication.user,
                        date: moment().format("YYYY-MM-DD HH:mm:ss"),
                    })),
                );

                this.processing = false;
                this.updateBusDialog = false;
                this.bus = "";

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
</style>
